import React from 'react';
import PropTypes from 'prop-types';

const moment = require('moment');

function PatrolLog({ visited, unvisited }) {
    let vIdx = 1;
    let clocked = visited.list.map(serialNumber => {
        let p = visited.serialNumber[serialNumber];
        return (
            <div key={serialNumber} >
                <span className='h6 font-italic'>
                    {vIdx++}: {p.name}
                    <div className='text-muted ml-3'>
                        {
                            p.list.map(posTimestamp => {
                                return (
                                    <div key={posTimestamp}>
                                        <small >
                                            {moment(posTimestamp).format('YYYY/MM/DD h:mm:ss A')}
                                        </small>
                                        <br />
                                    </div>
                                )
                            })
                        }
                    </div>
                </span>
            </div >
        );
    })

    let unclocked = null;
    if (unvisited) {
        let uIdx = 1;
        unclocked = unvisited.list.map(serialNumber => {
            let p = unvisited.serialNumber[serialNumber];
            return (
                <div key={serialNumber}>
                    <span className='h6 font-italic text-muted'>
                        {uIdx++}: {p.name}
                    </span>
                </div>
            );
        })
    }


    return (
        <div>
            {clocked}
            <br />
            {unclocked}
        </div>
    )
}

PatrolLog.propTypes = {
    visited: PropTypes.object,
    unvisited: PropTypes.object
};

export default PatrolLog;




// WEBPACK FOOTER //
// ./src/components/blocks/PatrolLog/PatrolLog.js